/* eslint-disable */
import { isEmptyObj, isEmptyStr } from '../utils/utils';

export const menuConfig = [
  {
    name: '首页',
    id: 'A',
    path: 'home',
    children: [],
  },
  {
    name: '交易中心',
    id: 'B',
    icon: 'trading',
    path: 'trading',
    children: [
      {
        name: '交易管理',
        id: 'BA',
        icon: 'trading-manage',
        path: 'trading-manage',
        children: [
          {
            name: '交易查询',
            id: 'BA01',
            path: 'trading-query',
          },
          {
            name: '申请批量退款',
            id: 'BA02',
            path: 'refund-upload',
            children: [
              {
                name: '测试四级菜单',
                id: 'BA01',
                path: 'test-4',
              },
            ],
          },
          {
            name: '批量退款批次查询',
            id: 'BA03',
            path: 'refund-batchQuery',
          },
          {
            name: '退款申请列表',
            id: 'BA04',
            path: 'refund-applyQuery',
          },
        ],
      },
      {
        name: '结算管理',
        id: 'BB',
        icon: 'settle-manage',
        path: 'settle-manage',
        children: [
          {
            name: '结算明细',
            id: 'BB02',
            path: 'settle-detail',
          },
          {
            name: '手续费查询',
            id: 'charge-query',
            path: 'charge-query',
          },
        ],
      },
    ],
  },
  {
    name: '产品服务',
    path: 'product',
    children: [
      {
        name: '我的产品',
        id: 'my-product',
        icon: 'my-product',
        path: 'my-product',
      },
      {
        name: '产品大全',
        id: 'prd-gather',
        icon: 'prd-gather',
        path: 'prd-gather',
      },
    ],
  },
  {
    name: '商户管理',
    id: 'E',
    icon: 'merchant',
    path: 'merchant',
    children: [
      {
        name: '商户信息管理',
        icon: 'merchant-information',
        path: 'merchant-information',
        children: [],
      },
      {
        name: '操作员权限管理',
        id: 'EA',
        icon: 'operator-authority',
        path: 'operator-authority',
        children: [
          {
            name: '操作员列表',
            id: 'EA01',
            path: 'operator-list',
          },
          {
            name: '角色管理',
            id: 'EA02',
            path: 'role-manage',
          },
        ],
      },
      {
        name: '安全设置',
        icon: 'security-settings',
        path: 'security-settings',
        children: [],
      },
    ],
  },
  {
    name: '营销中心',
    id: 'F',
    icon: 'marketing',
    path: 'marketing',
    children: [],
  },
];

export const getMenuConfig = () => {
  return JSON.parse(JSON.stringify(menuConfig));
};

export const getSiderMenu = (menudata, key) => {
  let result = [];
  let curKey = '';
  let curName = '';
  // const config = getMenuConfig();
  const config = JSON.parse(JSON.stringify(menudata));

  config.forEach((menu) => {
    /* if (key === menu.currentFullPath) {
      result = menu.children || [];
      curName = menu.name;
      curKey = menu.path;
    } */
    if (key === (`/${menu.path}`)) {
      curKey = menu.path;
      curName = menu.name;
      result = menu.children || [];
      result.forEach((item, i) => {
        result[i].path = `/${menu.path}/${item.path}`;
        const listb = item.children || [];
        if (listb.length > 0) {
          listb.forEach((itemb, j) => {
            result[i].children[j].path = `${result[i].path}/${itemb.path}`;
          });
        } else {
          result[i].children = [];
        }
      });
    }
  });

  const result2 = {
    name: curName,
    path: curKey,
    siderList: result,
  };

  return result2;
};

const getMenuConfigById = (id, configs) => {
  for (let i in configs) {
    let c = configs[i];

    if (!isEmptyObj(c) && !isEmptyStr(c.id) && !isEmptyStr(id) && c.id === id) {
      return c;
    }
  }

  return null;
};

export const convertToMenuConfigs = (rawData, configs, parentPath, btnList) => {
  let selectedConfigs = [];

  if (!isEmptyObj(rawData) && !isEmptyObj(configs)) {
    for (let i in rawData) {
      let r = rawData[i];
      if (isEmptyObj(r)) {
        continue;
      }

      let c = getMenuConfigById(r.menuId, configs);
      if (isEmptyObj(c)) {
        continue;
      }

      // 向Config对象中增加permissionIds、menuSeq、resourceLevel属性
      c.permissionIds = r.permissionIds;
      c.menuSeq = r.menuSeq || 0;//若无些属性，默认为0，排在最前
      c.menuLevel = parseInt(r.menuLevel);
      c.name = r.menuName;

      // 退款审核菜单命名特殊处理
      // if(r.menuId === 'BA04') {
      //   const list = btnList || [];
      //   let flag = 0;
      //   list.forEach((item) => {
      //     if (item.buttonId === 'AA04003' || item.buttonId === 'AA04004') {
      //       flag = 1;
      //       c.name = '退款审核';
      //     }
      //   });

      //   c.name = flag === 1 ? '退款审核' : '退款记录';
      // }

      // 当前结点全路径
      c.currentFullPath = parentPath + "/" + c.path;

      // 当前结点跳转路径
      c.redirectFullPath = c.currentFullPath;

      // 处理子级
      c.children = convertToMenuConfigs(r.menuList, c.children, c.currentFullPath, btnList);

      if (!isEmptyObj(c.children) && c.children.length > 0 && !isEmptyObj(c.children[0])) {
        c.redirectFullPath = c.children[0].redirectFullPath;
      }

      selectedConfigs.push(c);
    }

    // 按menuSeq排序
    selectedConfigs.sort((a, b) => {
      return parseInt(a.menuSeq) - parseInt(b.menuSeq);
    });
  }
  return selectedConfigs;
};




// WEBPACK FOOTER //
// ./src/routes/menuUtils.js